import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

export const VenueEditForm = ({ venue, csrfToken, onBack, onSaved }) => {
  const [groups, setGroups] = useState([]);
  const [form, setForm] = useState({ name: venue.name, address: venue.address || "",
    phone: venue.phone || "", website: venue.website || "", activity_type: venue.activity_type || "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/map/groups").then(({ data }) => setGroups(data.groups))
    .catch((e) => setError(errorMessage(e))); }, []);
  const update = (key, value) => setForm((before) => ({ ...before, [key]: value }));
  const save = async (event) => {
    event.preventDefault(); setBusy(true); setError("");
    try { await api.put(`/venues/${venue.id}`, { ...form, activity_type: form.activity_type || null },
      { headers: { "X-CSRF-Token": csrfToken } }); await onSaved(); }
    catch (e) { setError(errorMessage(e)); }
    finally { setBusy(false); }
  };
  return <form className="venue-edit-form" onSubmit={save} data-testid="venue-edit-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="venue-edit-back">‹ Scheda locale</button>
    <h2 className="sheet-title" data-testid="venue-edit-title">CORREGGI LOCALE</h2>
    {[['name', 'NOME', true], ['address', 'INDIRIZZO'], ['phone', 'TELEFONO'], ['website', 'SITO']].map(([field, label, required]) =>
      <div className="form-field" key={field}><label htmlFor={`venue-edit-${field}`}>{label}</label>
        <input id={`venue-edit-${field}`} value={form[field]} onChange={(e) => update(field, e.target.value)}
          maxLength={field === "name" ? 150 : field === "website" ? 300 : field === "phone" ? 35 : 255}
          required={required} type={field === "website" ? "url" : field === "phone" ? "tel" : "text"}
          data-testid={`venue-edit-${field}`} /></div>)}
    <div className="form-field"><label htmlFor="venue-edit-type">TIPOLOGIA CORRETTA</label>
      <select id="venue-edit-type" value={form.activity_type} onChange={(e) => update("activity_type", e.target.value)}
        data-testid="venue-edit-activity-type"><option value="">Non indicata</option>
        {groups.map((group) => <optgroup key={group.id} label={`${group.id} · ${group.name}`}>
          {group.keywords.map((word) => <option key={word} value={word}>{word}</option>)}</optgroup>)}</select></div>
    {error && <p role="alert" className="form-error" data-testid="venue-edit-error">{error}</p>}
    <button type="submit" className="hud-button" disabled={busy} data-testid="venue-edit-save">Salva correzioni</button>
  </form>;
};